import React from "react";

const ChatHeader = () => {
  return (
    <div className="card-header border-0">
      <div className="msg_head">
        <div className="d-flex bd-highlight align-items-center">
          <a
            id="back_user_list"
            href="javascript:void(0)"
            className="back-user-list"
          >
            <i className="fas fa-chevron-left"></i>
          </a>
          <div className="avatar avatar-lg online flex-shrink-0 me-2">
            <img
              src="https://img.freepik.com/free-vector/3d-ai-robot-character-chat-bot-wink-mascot-icon_107791-30020.jpg"
              alt="User"
            />
          </div>
          <div>
            <h6 className="fs-16 fw-medium mb-1">Chat Bot AI</h6>
          </div>
        </div>
        <div className="d-flex align-items-center send-action">
          <a
            className="btn chat-search-btn send-action-btn"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Search"
          >
            <i className="isax isax-search-normal-14"></i>
          </a>
          <a
            className="btn no-bg send-action-btn rounded-circle"
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-dots-vertical"></i>
          </a>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="#" className="dropdown-item">
                <i className="isax isax-close-circle me-2"></i>Đóng Chat
              </a>
            </li>
            <li>
              <a className="dropdown-item">
                <i className="fa-solid fa-volume-xmark me-2"></i>Tắt Thông Báo
              </a>
            </li>
            <li>
              <a className="dropdown-item">
                <i className="isax isax-clock me-2"></i>Tin nhắn tự xóa
              </a>
            </li>
            <li>
              <a className="dropdown-item">
                <i className="isax isax-refresh me-2"></i>Xóa Tin Nhắn
              </a>
            </li>
            <li>
              <a className="dropdown-item">
                <i className="isax isax-trash me-2"></i>Xóa Chat
              </a>
            </li>
            <li>
              <a className="dropdown-item">
                <i className="fa-regular fa-thumbs-down me-2"></i>Báo Cáo
              </a>
            </li>
            <li>
              <a className="dropdown-item">
                <i className="fa-solid fa-ban me-2"></i>Chặn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="chat-search search-wrap contact-search">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Tìm kiếm liên hệ"
          />
          <span className="input-group-text">
            <i className="isax isax-search-normal-14"></i>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
